import React from "react";

const BlogLine = ({color = "currentColor"}) => (
    <svg width="25" height="25" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
        <path
            d="M15.338 16.467l-2.109-2.112a1.01 1.01 0 111.43-1.429l2.17 2.175.01-.009.002-.003-1.381-1.39a1.01 1.01 0 011.434-1.424l1.28 1.288c1.613-2.086 2.97-4.76 4.078-7.756.424-1.144.782-2.26 1.078-3.308.185-.657.315-1.173.384-1.485.002-.007-.011-.02-.036-.012l-.065.016c-.778.127-1.818.338-3.058.657-1.9.49-3.781 1.113-5.539 1.885-.001 0-.004.004-.004.008 0 .954-.426 1.95-1.119 2.944l-.91 1.305V4.591c0-.007-.009-.013-.014-.01-5.531 2.627-9.426 9.97-6.887 13.43l.253.347L.718 23.98a.012.012 0 000 .016.01.01 0 00.014 0l5.619-5.625.348.268c2.047 1.573 5.42.513 8.64-2.173z"
            fillRule="nonzero"
            stroke={color}
            fill="none"
        />
    </svg>
);

export default BlogLine;
